export default "__VITE_ASSET__9c235b52__"